export default __webpack_public_path__ + "cff4c191f2a6f7a394d2c6eaab1fce0a.mp3";